<script lang="ts">
  var countDownDate = new Date("Jan 5, 2024 15:37:25").getTime();
  // Get today's date and time
  var now, distance, days, hours, minutes, seconds;
// Find the distance between now and the count down date
var distance;
  // Update the count down every 1 second
  var x = setInterval(function () {
    now = new Date().getTime();
    distance = countDownDate - now;
    // Time calculations for days, hours, minutes and seconds
    days = Math.floor(distance / (1000 * 60 * 60 * 24));
    hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // If the count down is finished, write some text
    if (distance < 0) { 
      clearInterval(x);
    }
  }, 1000);
</script>
<div class="countdown" id="clockdiv">
  {#if distance > 0}
    <ul>
      <li><span class="time">{days}</span><span class="title">days</span></li>
      <li><span class="time">{hours}</span><span class="title">hours</span></li>
      <li><span class="time">{minutes}</span><span class="title">minutes</span></li>
      <li><span class="time">{seconds}</span><span class="title">seconds</span></li>
    </ul>
  {:else}
    <h2>The time has come!</h2> 
  {/if}
</div>
